import { authedApiFetch } from '../../utils/Api';

export const action = async ({ params, request }) => {
	try {
		const formData = await request.formData();
		const jobId = params.jobId || formData.get('jobId');

		if (!jobId) {
			throw new Error('Job ID is required');
		}

		await authedApiFetch({
			endpoint: `/email/jobs/${jobId}/sync`,
			method: 'POST',
		});

		return { success: true, message: 'Successfully started sync to SF' };
	} catch (error) {
		console.error('Error syncing job:', error);
		return { success: false, message: 'Failed to start sync to SF' };
	}
};
